import MDAlert from "components/MDAlert";
import { CreateProductGroupInput } from "generated/graphql";
import useCreateProductGroup from "hooks/products/useCreateProductGroup";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";
import { getRoute } from "utils/routing";
import ProductGroupCreateForm from "./Forms/ProductGroupCreateForm";

export default function ProductGroupCreate() {
  const navigate = useNavigate();
  const [createProductGroup, { loading, error, isSuccess, getData }] = useCreateProductGroup();

  const handleSubmit = useCallback(
    async (input: CreateProductGroupInput) => {
      const result = await createProductGroup({ variables: { input } });
      const success = isSuccess(result.data);
      if (success) {
        navigate("/product-groups");
      }
      return { success, data: getData(result) };
    },
    [createProductGroup, isSuccess, getData, navigate]
  );

  return (
    <>
      {error && <MDAlert color="error">{parseGraphQLError(error)}</MDAlert>}
      <ProductGroupCreateForm loading={loading} onSubmit={handleSubmit} />
    </>
  );
}
